import { jsxs as t, jsx as l } from "react/jsx-runtime";
const o = ({ className: e, width: a = "24", height: i = "24" }) => /* @__PURE__ */ t(
  "svg",
  {
    className: e,
    width: a,
    height: i,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 19.364a7.364 7.364 0 1 0 0-14.728 7.364 7.364 0 0 0 0 14.728ZM12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
          fill: "#AFB5B9"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M14.314 8.529a.818.818 0 0 1 1.157 1.157L9.686 15.47a.818.818 0 1 1-1.157-1.157l5.785-5.785Z",
          fill: "#AFB5B9"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M8.529 9.686a.818.818 0 0 1 1.157-1.157l5.785 5.785a.818.818 0 0 1-1.157 1.157L8.53 9.686Z",
          fill: "#AFB5B9"
        }
      )
    ]
  }
);
export {
  o as default
};
